module.exports = __webpack_public_path__ + "img/step08_a_stand_power_identify_brackets_rear_cross.ed786e9b.png";